import { Close } from '@mui/icons-material';
import { IconButton, Portal, Stack, Typography } from '@mui/material';
import { FileItem } from 'api/files';
import React, { useRef } from 'react';

import { getFileType } from '../utils/getFileType';

export function FilePreviewModal(props: {
  previewFile: FileItem | null;
  onClose: () => void;
}) {
  const { previewFile, onClose } = props;

  const previewFileRef = useRef<FileItem | null>(previewFile);

  if (previewFile) previewFileRef.current = previewFile;

  const fileType = previewFileRef.current
    ? getFileType(previewFileRef.current.name)
    : null;

  return (
    <Portal>
      <div
        style={{
          position: 'fixed',
          zIndex: 9999999,
          width: '100vw',
          height: '100vh',
          top: 0,
          left: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          pointerEvents: previewFile ? 'auto' : 'none',
          padding: '5vh 5vw',
        }}
      >
        <Stack
          sx={{
            opacity: previewFile ? 1 : 0,
            backgroundColor: 'rgba(0, 0, 0, 0.2)',
            transform: previewFile ? 'none' : 'scale(0.8)',
            transition: `
              transform 0.4s cubic-bezier(0.16, 1, 0.3, 1),
              opacity 0.4s cubic-bezier(0.16, 1, 0.3, 1)
            `,
            backdropFilter: 'blur(20px) saturate(2)',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            borderRadius: 3,
            overflow: 'hidden',
            height: '100%',
            width: '100%',
          }}
        >
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            pl={3}
            sx={{
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
              borderBottom: '1px solid rgba(255, 255, 255, 0.2)',
            }}
          >
            <Typography variant="body2">
              {previewFileRef.current?.name}
            </Typography>
            <IconButton size="small" onClick={() => onClose?.()}>
              <Close />
            </IconButton>
          </Stack>
          {fileType === 'image' && previewFileRef.current && (
            <img
              src={previewFileRef.current?.url}
              alt={previewFileRef.current.name}
              style={{
                objectFit: 'contain',
                minHeight: 0,
                minWidth: 0,
              }}
            />
          )}
        </Stack>
      </div>
    </Portal>
  );
}
